import { strFromU8, unzipSync } from "fflate";
import { parseBnyPershingIsca } from "./isca";

export const MAX_PERSHING_ZIP_BYTES = 25 * 1024 * 1024;
export const MAX_ISCA_MEMBER_BYTES = 10 * 1024 * 1024;

export async function sha256Hex(bytes) {
  const cryptoApi = globalThis.crypto;
  if (!cryptoApi?.subtle) throw new Error("SHA-256 is not available in this browser.");
  const view = bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes);
  const digest = await cryptoApi.subtle.digest("SHA-256", view);
  return Array.from(new Uint8Array(digest), (value) => value.toString(16).padStart(2, "0")).join("");
}

export function extractBnyPershingIscaZip(bytes) {
  const archiveBytes = bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes);
  if (!archiveBytes.length) throw new Error("The selected ZIP file is empty.");
  if (archiveBytes.length > MAX_PERSHING_ZIP_BYTES) {
    throw new Error("The selected ZIP file exceeds the 25 MB upload limit.");
  }

  let archive;
  try {
    archive = unzipSync(archiveBytes, {
      filter: (entry) => /(^|\/)\d{6}\.ISCA$/i.test(entry.name)
        && entry.originalSize <= MAX_ISCA_MEMBER_BYTES,
    });
  } catch (error) {
    throw new Error(`Unable to open the Pershing ZIP file: ${error.message}`);
  }
  const memberNames = Object.keys(archive).filter((name) => /(^|\/)\d{6}\.ISCA$/i.test(name));
  if (!memberNames.length) throw new Error("The ZIP file does not contain a Pershing MMDDYY.ISCA file.");
  if (memberNames.length > 1) throw new Error("The ZIP file contains more than one ISCA file.");

  const memberName = memberNames[0];
  const memberBytes = archive[memberName];
  if (memberBytes.length > MAX_ISCA_MEMBER_BYTES) throw new Error("The ISCA file exceeds the 10 MB limit.");
  const contents = strFromU8(memberBytes);
  const parsed = parseBnyPershingIsca(contents);
  return { memberName, memberBytes, contents, parsed };
}

